export default "__VITE_ASSET__DBrgLv3I__"